export function timelineListGet(page) {
	return {
    type: 'TIMELINE_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export function timelineFootprintListGet(date, page) {
	return {
    type: 'TIMELINE_FOOTPRINT_LIST_GET',
		payload: {
			date: date,
			page: page,
		},
	}
}

export function timelinePostGoodUserListGet(date, page) {
	return {
    type: 'TIMELINE_POST_GOOD_USER_LIST_GET',
		payload: {
			date: date,
			page: page,
		},
	}
}
